import * as React from 'react';
import { Component } from 'react';
import { observer, inject } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import DownloadControls from './DownloadControls';
import Icon from './Icon';

const Wrapper = styled<any, any>('div')`
    ${propStyles};
    display: flex;
    align-items: center;
    flex-shrink: 0;
`;

Wrapper.defaultProps = {
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: ['none', 'none none solid none'],
    hover: {
        bgColor: ['transparent', 'gray100'],
    },
};

const checkboxStyleProps = {
    iconSize: 'sm',
    margin: '0 0.5em 0 0',
};

const Label = styled<any, any>('label')`
    ${propStyles};
    opacity: ${props => (props.disabled ? 0.5 : 1)};
    cursor: pointer;
`;

Label.defaultProps = {
    display: 'flex',
    color: 'body',
};

@inject('dataStore')
@observer
class DocumentCheckboxButton extends Component<any, any> {
    render() {
        const {
            theme,
            dataStore,
            selected,
            showCheckbox,
            onChange,
            count,
            showCount,
            document,
            ...props
        } = this.props;

        return (
            <Wrapper {...props}>
                {showCheckbox && (
                    <Label
                        data-selected={selected}
                        {...theme.DocumentSelectLabel}
                    >
                        <input
                            type="checkbox"
                            checked={selected}
                            onChange={onChange}
                            style={{ display: 'none' }}
                        />
                        {selected ? (
                            <Icon
                                fileName="CheckboxMarkedIcon"
                                {...checkboxStyleProps}
                                {...theme.CheckboxChecked}
                            />
                        ) : (
                            <Icon
                                fileName="CheckboxIcon"
                                {...checkboxStyleProps}
                                {...theme.CheckboxUnchecked}
                            />
                        )}
                    </Label>
                )}
                <DownloadControls
                    label={dataStore.getDocumentDisplayName(document)}
                    theme={{
                        ...theme,
                        ...{
                            DownloadButton:
                                theme.DocumentCheckboxDownloadButton,
                            DownloadCount: theme.DocumentCheckboxDownloadCount,
                        },
                    }}
                    onClick={() => dataStore.downloadDocuments([document])}
                    count={count}
                    showCount={showCount}
                />
            </Wrapper>
        );
    }
}

export default withTheme(DocumentCheckboxButton) as any;



// WEBPACK FOOTER //
// ./src/Components/DocumentCheckboxButton.tsx